import React from 'react';
import { Button } from '@mui/material';
import { Upload } from '@mui/icons-material';

const UploadButton = ({ name, onChange, disabled }) => {
  let input;
  return (
    <React.Fragment>
      <Button
        onClick={(e) => {
          e.preventDefault();
          input.click();
        }}
        disabled={disabled}
        variant='outlined'
        endIcon={<Upload />}
      >
        {name}
      </Button>

      <input
        ref={(element) => (input = element)}
        hidden
        onChange={(e) => {
          e.preventDefault();
          onChange(e);
        }}
        type='file'
      />
    </React.Fragment>
  );
};
export default UploadButton;
